module.exports = __webpack_public_path__ + "static/media/googlePlayIcon.4ee68471.svg";